var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart-card',{attrs:{"title":"안전보건 예산 현황","value":_vm.data,"total":_vm.total,"unit":"천원","isMoveWrite":_vm.isMoveWrite,"is-move-detail":!!_vm.projectId,"orientation":_vm.orientation},on:{"detail":_vm.onClickDetail,"write":_vm.onClickWrite}})
}
var staticRenderFns = []

export { render, staticRenderFns }